<nav class="nav-bar">
  @if (!isOpen) {
    <div class="container p-sm-0">
      <div class="nav-content">
        <!-- NOTIFICATIONS -->
        @if (isSmallScreen && isAuthenticated$()) {
          <div class="notifications-colum">
            <nmfta-button
              [blackText]="true"
              type="icon"
              iconName="notifications"
              (buttonClick)="navigate('whats-new')"></nmfta-button>
          </div>
        }

        <!-- LOGO -->
        <div class="logo-column" [ngClass]="{ 'logo-center': isSmallScreen }" [routerLink]="'home'">
          <img src="assets/images/classit_logo_white.svg" alt="logo" />
        </div>

        <!-- MENU -->
        @if (isSmallScreen) {
          <!-- DROPDOWN MENU -->
          <div class="menu-colum">
            <nmfta-button [blackText]="true" type="icon" iconName="menu" (buttonClick)="toggleNavMenu()"></nmfta-button>
          </div>
        } @else {
          <!-- HORIZONTAL MENU -->
          <div class="button-column">
            <div class="button-row">
              @if (isOktaLoginCallback$() || userLoading$()) {
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '15em',
                    height: '2rem',
                    'border-radius': '0.5rem',
                  }">
                </ngx-skeleton-loader>
              } @else {
                @if (isAuthenticated$()) {
                  <!-- USER MENU-->
                  <nmfta-button
                    [blackText]="true"
                    [matMenuTriggerFor]="menuUser"
                    leftIcon="person"
                    rightIcon="keyboard_arrow_down">
                    {{ user$.firstName!() + ' ' + user$.lastName!() }}
                  </nmfta-button>
                  <mat-menu #menuUser="matMenu">
                    <button mat-menu-item [routerLink]="'profile/user-profile'">
                      <nmfta-icon name="person"></nmfta-icon>
                      {{ 'Generic_UserProfile' | translate }}
                    </button>
                    @if (user$.features!().CompanySettings) {
                      <button mat-menu-item [routerLink]="'profile/company-settings'">
                        <nmfta-icon name="apartment"></nmfta-icon>
                        {{ 'Generic_CompanySettings' | translate }}
                      </button>
                    }
                    <button mat-menu-item class="custom-red-button" (click)="signOut()">
                      <nmfta-icon name="logout" class="custom-red-button"></nmfta-icon>
                      {{ 'Generic_Logout' | translate }}
                    </button>
                  </mat-menu>

                  @if (user$.features!().AdminMenu) {
                    <!-- ADMIN MENU -->
                    <nmfta-button
                      [blackText]="true"
                      [matMenuTriggerFor]="menuAdmin"
                      leftIcon="build"
                      rightIcon="keyboard_arrow_down">
                      Admin Menu
                    </nmfta-button>
                    <mat-menu #menuAdmin="matMenu">
                      <button mat-menu-item [routerLink]="'admin/company'">
                        {{ 'Generic_ManageCompanies' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/users'">
                        {{ 'Generic_ManageAllUsers' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/invoices'">
                        {{ 'Generic_ManageInvoices' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/products'">
                        {{ 'Generic_ManageProducts' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/news-feed'">
                        {{ 'Generic_ManageNewsFeed' | translate }}
                      </button>
                      <button mat-menu-item [routerLink]="'admin/book-orders'">
                        Manage Book Orders
                      </button>
                    </mat-menu>
                  }
                } @else {
                  <!-- LOGIN -->
                  <nmfta-button [blackText]="true" leftIcon="login" (buttonClick)="signIn()">
                    {{ 'Generic_Login' | translate }}
                  </nmfta-button>
                }
                <!-- LANGUAGE -->
                <nmfta-button
                  [blackText]="true"
                  [matMenuTriggerFor]="menuLanguage"
                  leftIcon="language"
                  rightIcon="keyboard_arrow_down">
                  {{ langLabel }}
                </nmfta-button>
                <mat-menu #menuLanguage="matMenu">
                  <button mat-menu-item (click)="useLanguage('en')">
                    @if (langSelected === 'en') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_English' | translate }}
                  </button>
                  <button mat-menu-item (click)="useLanguage('fr')">
                    @if (langSelected === 'fr') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_French' | translate }}
                  </button>
                  <button mat-menu-item (click)="useLanguage('es')">
                    @if (langSelected === 'es') {
                      <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                    }
                    {{ 'Generic_Spanish' | translate }}
                  </button>
                </mat-menu>
                @if (isAuthenticated$() && news$().length && !displayingBanner$()) {
                  <!-- News Bullhorn-->
                  <nmfta-button
                    [blackText]="true"
                    type="icon"
                    iconName="bullhorn"
                    (buttonClick)="showBanner()"></nmfta-button>
                }

                @if (isAuthenticated$()) {
                  <!-- NOTIFICATIONS -->
                  <nmfta-button
                    [blackText]="true"
                    type="icon"
                    iconName="notifications"
                    (buttonClick)="navigate('whats-new')"></nmfta-button>
                }
              }
            </div>

            <div class="button-row">
              @if (isOktaLoginCallback$() || userLoading$()) {
                <ngx-skeleton-loader
                  count="1"
                  [theme]="{
                    width: '30rem',
                    height: '2rem',
                    'border-radius': '0.5rem',
                  }">
                </ngx-skeleton-loader>
              } @else {
                @if (isAuthenticated$() && user$().role !== accountManager) {
                  <!-- SEARCH -->
                  <nmfta-button [blackText]="true" (buttonClick)="navigate('home')">
                    {{ 'Generic_Search' | translate }}
                  </nmfta-button>

                  <!-- WHAT'S NEW -->
                  <nmfta-button [blackText]="true" (buttonClick)="navigate('whats-new')">
                    {{ 'Generic_WhatsNew' | translate }}
                  </nmfta-button>

                  <!-- COMING SOON -->
                  <nmfta-button [blackText]="true" (buttonClick)="navigate('coming-soon')">
                    {{ 'Generic_ComingSoon' | translate }}
                  </nmfta-button>

                  <!-- CALCULATOR -->
                  <nmfta-button [blackText]="true" (buttonClick)="navigate('calculator')">
                    {{ 'Generic_Calculator' | translate }}
                  </nmfta-button>

                  <!-- MY RESOURCES -->
                  <nmfta-button [blackText]="true" rightIcon="keyboard_arrow_down" [matMenuTriggerFor]="menuNmfcBook">
                    {{ 'Generic_MyResources' | translate }}
                  </nmfta-button>
                  <mat-menu #menuNmfcBook="matMenu">
                    <button mat-menu-item [routerLink]="'search-history'">
                      {{ 'Generic_MySearchHistory' | translate }}
                    </button>
                    <button mat-menu-item [routerLink]="'favorites'">
                      {{ 'Generic_MyFavorites' | translate }}
                    </button>
                    @if (user$().isCompanySynonymsEnabled && user$().isUserSynonymsEnabled) {
                      <button mat-menu-item [routerLink]="'synonyms'">
                        {{ 'Generic_MySynonyms' | translate }}
                      </button>
                    }
                    @if (user$().enableComments) {
                      <button mat-menu-item [routerLink]="'comments'">
                        {{ 'Generic_MyComments' | translate }}
                      </button>
                    }
                    <button mat-menu-item [routerLink]="'nmfc-book'">
                      {{ 'Generic_NMFCBook' | translate }}
                    </button>
                    @if (user$().isCompanyCommonEnabled) {
                      <button mat-menu-item [routerLink]="'company-common'">
                        {{ 'Generic_CompanyCommon' | translate }}
                      </button>
                    }
                  </mat-menu>
                }
                <!-- PURCHASE -->
                <nmfta-button
                  [blackText]="true"
                  rightIcon="keyboard_arrow_down"
                  [matMenuTriggerFor]="menuNmfcProducts">
                  {{ 'Generic_Purchase' | translate }}
                </nmfta-button>
                <mat-menu #menuNmfcProducts="matMenu">

                  @if ( user$().features.PurchaseMenu || !isAuthenticated$() ) {
                    <button mat-menu-item [routerLink]="'purchase'">ClassIT+ Products</button>
                  }

                  <button mat-menu-item [routerLink]="'purchase'" [queryParams]="{ product: 'nmfc-book' }">
                    {{ 'Generic_NMFCBook' | translate }}
                  </button>
                  <button
                    mat-menu-item
                    (click)="routeToExternalLink('https://store.nmfta.org/category/interpretations')">
                    {{ 'Generic_ClassificationInterpretationAssistance' | translate }}
                  </button>
                  <button
                    mat-menu-item
                    (click)="routeToExternalLink('https://store.nmfta.org/category/NMFCSeminars')">
                    {{ 'Generic_NMFCWebinarsSeminars' | translate }}
                  </button>
                  <button mat-menu-item (click)="routeToExternalLink('https://store.nmfta.org/category/nmfcother')">
                    {{ 'Generic_FCDCShipperPackagingRegistration' | translate }}
                  </button>
                </mat-menu>

                @if (!isAuthenticated$()) {
                  <!-- CONTACT SUPPORT -->
                  <nmfta-button [blackText]="true" (buttonClick)="routeToExternalLink('https://nmfta.org/contact/')">
                    {{ 'Generic_ContactSupport' | translate }}
                  </nmfta-button>

                  <!-- ABOUT THE NMFC -->
                  <nmfta-button [blackText]="true" (buttonClick)="routeToExternalLink('https://nmfta.org/nmfc')">
                    {{ 'Generic_AboutTheNMFC' | translate }}
                  </nmfta-button>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</nav>

<ng-template #nmfcBookModalTemplate>
  <div class="container-fluid">
    <div class="row p-1 p-md-3">
      <div class="row p-1 p-md-3">
        <p class="welcome-message" [innerHTML]="'NMFC_BOOK.2026_BOOK_AVAILABLE_MESSAGE' | translate"></p>
      </div>
    </div>
  </div>
</ng-template>

<div class="overlay" [class.open]="isOpen">
  <div class="nav-menu-content" [class.d-none]="!isOpen">
    <div class="nav-menu-header container">
      <div class="logo-column logo-mobile" (click)="navigate('home')">
        <img src="assets/images/classit_logo_white.svg" alt="logo" />
      </div>
      <div class="menu-colum">
        <!-- CLOSE MENU -->
        <nmfta-button [blackText]="true" type="icon" iconName="close" (buttonClick)="toggleNavMenu()"></nmfta-button>
      </div>
    </div>

    <div class="nav-menu-body container">
      @if (isAuthenticated$()) {
        <nmfta-search-bar></nmfta-search-bar>
      }

      @if (userLoading$()) {
        <div class="menu-loading">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '12rem',
              'border-radius': '0.5rem',
            }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="2"
            [theme]="{
              width: '100%',
              height: '6rem',
              'border-radius': '0.5rem',
            }">
          </ngx-skeleton-loader>
        </div>
      } @else {
        <div class="menu-items">
          <mat-accordion>
            @if (isAuthenticated$()) {
              <div matRipple class="menu-item" (click)="navigate('home')">
                <span>{{ 'Generic_Home' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="navigate('whats-new')">
                <span>{{ 'Generic_WhatsNew' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="navigate('coming-soon')">
                <span>{{ 'Generic_ComingSoon' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="navigate('calculator')">
                <span>{{ 'Generic_Calculator' | translate }}</span>
              </div>
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ 'Generic_MyResources' | translate }}</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div matRipple class="menu-item" (click)="navigate('search-history')">
                  <span>{{ 'Generic_MySearchHistory' | translate }}</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('favorites')">
                  <span>{{ 'Generic_MyFavorites' | translate }}</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('synonyms')">
                  <span>{{ 'Generic_MySynonyms' | translate }}</span>
                </div>
                @if (user$().enableComments) {
                  <div matRipple class="menu-item" (click)="navigate('comments')">
                    <span>{{ 'Generic_MyComments' | translate }}</span>
                  </div>
                }
                <div matRipple class="menu-item" (click)="navigate('nmfc-book')">
                  <span>{{ 'Generic_NMFCBook' | translate }}</span>
                </div>
                <div matRipple class="menu-item" (click)="navigate('company-common')">
                  <span>{{ 'Generic_CompanyCommon' | translate }}</span>
                </div>
              </mat-expansion-panel>
            } @else {
              <div matRipple class="menu-item" (click)="routeToExternalLink('https://nmfta.org/nmfc')">
                {{ 'Generic_AboutTheNMFC' | translate }}
              </div>
            }

            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header class="no-border">
                <mat-panel-title>{{ 'Generic_Purchase' | translate }}</mat-panel-title>
                <mat-icon class="custom-icon">expand_more</mat-icon>
              </mat-expansion-panel-header>

              @if ( user$().features.PurchaseMenu || !isAuthenticated$() ) {
                <div matRipple class="menu-item" (click)="navigate('purchase')">
                  <span>ClassIT+ Products</span>
                </div>
              }
              <div matRipple class="menu-item" [routerLink]="'purchase'" [queryParams]="{ product: 'nmfc-book' }">
                <span>{{ 'Generic_NMFCBook' | translate }}</span>
              </div>
              <div
                matRipple
                class="menu-item"
                (click)="routeToExternalLink('https://store.nmfta.org/category/interpretations')">
                <span>{{ 'Generic_ClassificationInterpretationAssistance' | translate }}</span>
              </div>
              <div
                matRipple
                class="menu-item"
                (click)="routeToExternalLink('https://store.nmfta.org/category/NMFCSeminars')">
                <span>{{ 'Generic_NMFCWebinarsSeminars' | translate }}</span>
              </div>
              <div
                matRipple
                class="menu-item no-border"
                (click)="routeToExternalLink('https://store.nmfta.org/category/nmfcother')">
                <span>{{ 'Generic_FCDCShipperPackagingRegistration' | translate }}</span>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <div class="menu-items">
          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
              <mat-expansion-panel-header [class.no-border]="!isAuthenticated$()">
                <mat-panel-title>
                  <mat-icon class="me-2">language</mat-icon>
                  <span>{{ langLabel }}</span>
                </mat-panel-title>
                <mat-icon class="custom-icon">expand_more</mat-icon>
              </mat-expansion-panel-header>
              <div matRipple class="menu-item" (click)="useLanguage('en')">
                @if (langSelected === 'en') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_English' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="useLanguage('fr')">
                @if (langSelected === 'fr') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_French' | translate }}</span>
              </div>
              <div matRipple class="menu-item" (click)="useLanguage('es')">
                @if (langSelected === 'es') {
                  <mat-icon fontSet="material-icons-outlined" class="me-2">check</mat-icon>
                }
                <span>{{ 'Generic_Spanish' | translate }}</span>
              </div>
            </mat-expansion-panel>
            @if (isAuthenticated$() && news$().length && !displayingBanner$()) {
              <!-- News Bullhorn-->
              <div matRipple class="menu-item" (click)="showBanner()">
                <nmfta-icon class="me-2" name="bullhorn"></nmfta-icon>
                <span>
                  {{ 'SHARED.SHOW_NEWS_BANNER' | translate }}
                </span>
              </div>
            }

            @if (isAuthenticated$()) {
              <div matRipple class="menu-item no-border" (click)="navigate('whats-new')">
                <mat-icon class="me-2">notifications</mat-icon>
                <span>
                  {{ 'Generic_Notifications' | translate }}
                </span>
              </div>
            }
          </mat-accordion>
        </div>

        <div class="menu-items">
          <mat-accordion>
            @if (isAuthenticated$()) {
              <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ user$.firstName!() + ' ' + user$.lastName!() }}</mat-panel-title>
                  <mat-icon class="custom-icon">expand_more</mat-icon>
                </mat-expansion-panel-header>
                <div matRipple class="menu-item" (click)="navigate('profile/user-profile')">
                  <mat-icon class="me-2">person</mat-icon>
                  <span>{{ 'Generic_UserProfile' | translate }}</span>
                </div>
                @if (user$.features!().CompanySettings) {
                  <div matRipple class="menu-item" (click)="navigate('profile/company-settings')">
                    <mat-icon class="me-2">apartment</mat-icon>
                    <span>{{ 'Generic_CompanySettings' | translate }}</span>
                  </div>
                }
                <div matRipple class="menu-item custom-red-button" (click)="signOut()">
                  <mat-icon class="me-2">logout</mat-icon>
                  <span>{{ 'Generic_Logout' | translate }}</span>
                </div>
              </mat-expansion-panel>

              @if (user$.features!().AdminMenu) {
                <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Admin Menu</mat-panel-title>
                    <mat-icon class="custom-icon">expand_more</mat-icon>
                  </mat-expansion-panel-header>
                  <div matRipple class="menu-item" (click)="navigate('admin/company')">
                    <span>{{ 'Generic_ManageCompanies' | translate }}</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/users')">
                    <span>{{ 'Generic_ManageAllUsers' | translate }}</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/products')">
                    <span>{{ 'Generic_ManageProducts' | translate }}</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/news-feed')">
                    <span>{{ 'Generic_ManageNewsFeed' | translate }}</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/invoices')">
                    <span>{{ 'Generic_ManageInvoices' | translate }}</span>
                  </div>
                  <div matRipple class="menu-item" (click)="navigate('admin/book-orders')">
                    <span>Manage Book Orders</span>
                  </div>

                </mat-expansion-panel>
              }
            } @else {
              <div matRipple class="menu-item" (click)="signIn()">
                <mat-icon class="me-2">login</mat-icon>
                <span>{{ 'Generic_Login' | translate }}</span>
              </div>
            }
            <div matRipple class="menu-item no-border" (click)="routeToExternalLink('https://nmfta.org/contact/')">
              {{ 'Generic_ContactSupport' | translate }}
            </div>
          </mat-accordion>
        </div>
      }
    </div>
  </div>
  <div class="nav-menu-footer">
    <p>
      All content © Copyright 2024 National Motor Freight Traffic Association, Inc.® (NMFTA).™
      <br />All Rights Reserved.
    </p>
  </div>
</div>
